/* ==========================================================================
   ASCEND — quick-add sheet

   The product card's "Add to cart" opens a sheet (bottom sheet on phones,
   centred dialog on desktop) where the shopper picks a size, a quantity and
   one-time vs Subscribe & Save, then adds to the cart without leaving the
   page. Product data (variants, prices, selling plans) is fetched on demand
   from the product's own page via the Section Rendering API
   (/products/<handle>?section_id=quick-add-data), so the catalog grids carry
   no extra weight.

   After a successful add the cart drawer is refreshed and opened through the
   same hooks the PDP uses (document event "ascend:cart:added").
   ========================================================================== */
(function () {
  'use strict';
  if (window.__ascendQuickAdd) return;
  window.__ascendQuickAdd = true;

  var sheet, panel, lastFocus, state = null, cache = {};

  /* Wording and toggles come from Theme settings -> Quick add popup, emitted
     by layout/theme.liquid as JSON. Every key has a fallback so the sheet
     still works if the block is missing. */
  var DEFAULTS = { size_label: 'Select size', qty_label: 'Quantity', sub_text: 'Subscribe & Save [percent]%. Cancel anytime.', add_label: 'Add to cart', adding_label: 'Adding...', soldout_label: 'Sold out', details_label: 'View full details', note: 'Not for human or veterinary use, and not for diagnostic or therapeutic use.', show_image: true, show_category: true, show_qty: true, show_sub: true, sub_default: true, show_total: true, show_details: true, show_note: true };
  var cfg = DEFAULTS;
  try {
    var cfgEl = document.querySelector('[data-quick-add-config]');
    if (cfgEl) { var parsed = JSON.parse(cfgEl.textContent); cfg = {}; for (var k in DEFAULTS) cfg[k] = (k in parsed) ? parsed[k] : DEFAULTS[k]; }
  } catch (e) { cfg = DEFAULTS; }

  function money(cents) {
    var fmt = (document.querySelector('[data-money-format]') || {}).dataset;
    fmt = fmt && fmt.moneyFormat ? fmt.moneyFormat : '${{amount}}';
    var v = (cents / 100);
    var s = v.toFixed(2).replace(/\.00$/, '');
    if (/\{\{\s*amount_no_decimals\s*\}\}/.test(fmt)) s = Math.round(v).toString();
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, s.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function build() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'qa';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="qa-backdrop" data-qa-close></div>' +
      '<div class="qa-panel" role="dialog" aria-modal="true" aria-labelledby="qa-title">' +
        '<div class="qa-grab" aria-hidden="true"></div>' +
        '<div class="qa-head">' +
          '<img class="qa-img" alt="" width="56" height="56">' +
          '<div class="qa-titles"><strong id="qa-title"></strong><small class="qa-cat"></small></div>' +
          '<button type="button" class="qa-x" data-qa-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
        '</div>' +
        '<div class="qa-body">' +
          '<div class="qa-block" data-qa-sizes-block><p class="qa-label">' + esc(cfg.size_label) + '</p><div class="qa-sizes" role="radiogroup" aria-label="Size" data-qa-sizes></div></div>' +
          '<div class="qa-block" data-qa-plan-block><div class="qa-plans" data-qa-plans></div></div>' +
          '<div class="qa-block qa-row"' + (cfg.show_qty ? '' : ' hidden') + '><p class="qa-label">' + esc(cfg.qty_label) + '</p><div class="qa-qty"><button type="button" data-qa-qty="-1" aria-label="Decrease quantity">&minus;</button><input type="text" inputmode="numeric" value="1" maxlength="3" aria-label="Quantity" data-qa-qty-input><button type="button" data-qa-qty="1" aria-label="Increase quantity">+</button></div></div>' +
        '</div>' +
        '<div class="qa-foot">' +
          '<button type="button" class="btn btn-primary btn-block qa-add" data-qa-add>' +
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4.6" y="8.2" width="14.8" height="12.6" rx="2.6"/><path d="M8.9 8.2V6.7a3.1 3.1 0 0 1 6.2 0v1.5"/></svg>' +
            '<span data-qa-add-label>' + esc(cfg.add_label) + '</span>' + (cfg.show_total ? '<span class="qa-dot">&middot;</span><span data-qa-total></span>' : '') +
          '</button>' +
          (cfg.show_details ? '<a class="qa-details" data-qa-details href="#">' + esc(cfg.details_label) + ' &rarr;</a>' : '') +
          (cfg.show_note && cfg.note ? '<p class="qa-ruo">' + esc(cfg.note) + '</p>' : '') +
        '</div>' +
      '</div>';
    document.body.appendChild(sheet);
    panel = sheet.querySelector('.qa-panel');
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-qa-close]')) { close(); return; }
      var size = e.target.closest('[data-qa-size]');
      if (size) {
        state.variantId = Number(size.getAttribute('data-qa-size'));
        var nv = state.product.variants.filter(function (x) { return x.id === state.variantId; })[0];
        if (state.planId && nv && nv.plans && nv.plans.length && !nv.plans.some(function (pl) { return String(pl.id) === String(state.planId); })) state.planId = nv.plans[0].id;
        render(); return;
      }
      if (e.target.closest('[data-qa-plan-row]') && !e.target.closest('input')) { /* label click toggles the input natively */ }
      var q = e.target.closest('[data-qa-qty]');
      if (q) { state.qty = Math.max(1, Math.min(999, state.qty + Number(q.getAttribute('data-qa-qty')))); render(); return; }
      if (e.target.closest('[data-qa-add]')) { add(); }
    });
    sheet.addEventListener('change', function (e) {
      var cb = e.target.closest('[data-qa-plan-toggle]');
      if (cb) { state.planId = cb.checked ? cb.getAttribute('data-qa-plan-toggle') : ''; render(); }
    });
    sheet.querySelector('[data-qa-qty-input]').addEventListener('change', function (e) {
      var v = parseInt(e.target.value, 10); state.qty = isNaN(v) || v < 1 ? 1 : Math.min(999, v); render();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet && !sheet.hidden) close(); });
  }

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '?section_id=quick-add-data', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-quick-add-product]');
        if (!el) throw new Error('no data');
        return JSON.parse(el.textContent);
      })
      .catch(function (e) { delete cache[handle]; throw e; });
    return cache[handle];
  }

  function current() {
    var v = state.product.variants.filter(function (x) { return x.id === state.variantId; })[0] || state.product.variants[0];
    var plan = null;
    if (state.planId) plan = (v.plans || []).filter(function (p) { return String(p.id) === String(state.planId); })[0] || null;
    return { v: v, plan: plan, unit: plan ? plan.price : v.price };
  }

  function render() {
    var p = state.product, c = current();
    sheet.querySelector('#qa-title').textContent = p.title;
    sheet.querySelector('.qa-cat').textContent = cfg.show_category ? (p.type || '') : '';
    var img = sheet.querySelector('.qa-img');
    if (p.image && cfg.show_image) { img.src = p.image; img.hidden = false; } else { img.hidden = true; }
    var det = sheet.querySelector('[data-qa-details]'); if (det) det.href = p.url;

    /* sizes */
    var sizesBlock = sheet.querySelector('[data-qa-sizes-block]');
    var sizes = sheet.querySelector('[data-qa-sizes]');
    var showSizes = p.variants.length > 1 || (p.variants[0] && p.variants[0].title !== 'Default Title');
    sizesBlock.hidden = !showSizes;
    sizes.innerHTML = p.variants.map(function (v) {
      var sel = v.id === c.v.id;
      var plan = state.planId ? (v.plans || []).filter(function (x) { return String(x.id) === String(state.planId); })[0] : null;
      var price = plan ? plan.price : v.price;
      return '<button type="button" class="qa-size' + (sel ? ' is-selected' : '') + (v.available ? '' : ' is-soldout') + '" role="radio" aria-checked="' + sel + '" data-qa-size="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        '<span class="qa-size-name">' + esc(v.title) + '</span>' +
        '<span class="qa-size-price">' + (v.available ? money(price) + (v.compare > price ? ' <s>' + money(v.compare) + '</s>' : '') : 'Sold out') + '</span></button>';
    }).join('');

    /* purchase option */
    var plansBlock = sheet.querySelector('[data-qa-plan-block]');
    var plans = sheet.querySelector('[data-qa-plans]');
    var vplans = c.v.plans || [];
    plansBlock.hidden = !vplans.length || !cfg.show_sub;
    if (vplans.length && cfg.show_sub) {
      /* Mirrors the product page's Subscribe & Save row exactly (same classes),
         so the two surfaces stay visually identical. First plan on the variant. */
      var pl = vplans[0];
      var on = String(state.planId) === String(pl.id);
      var pct = c.v.price ? Math.round((c.v.price - pl.price) * 100 / c.v.price) : 0;
      var save = c.v.price - pl.price;
      plans.innerHTML =
        '<label class="pdp-sub pdp-sub--compact qa-sub' + (on ? ' is-on' : '') + '" data-qa-plan-row>' +
          '<input type="checkbox" class="pdp-sub-check" data-qa-plan-toggle="' + pl.id + '"' + (on ? ' checked' : '') + '>' +
          '<span class="pdp-sub-title">' + esc(cfg.sub_text.replace(/\[percent\]%?/g, pct > 0 ? pct + '%' : '').replace(/\s+([.,])/g, '$1').replace(/\s{2,}/g, ' ').trim()) + '</span>' +
        '</label>';
    }

    sheet.querySelector('[data-qa-qty-input]').value = state.qty;
    var tot = sheet.querySelector('[data-qa-total]'); if (tot) tot.textContent = money(c.unit * state.qty);
    var addBtn = sheet.querySelector('[data-qa-add]');
    addBtn.disabled = !c.v.available;
    sheet.querySelector('[data-qa-add-label]').textContent = c.v.available ? (state.busy ? cfg.adding_label : cfg.add_label) : cfg.soldout_label;
  }

  function open(handle, trigger) {
    build();
    lastFocus = trigger || document.activeElement;
    sheet.hidden = false;
    panel.classList.add('is-loading');
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    document.body.classList.add('no-scroll');
    fetchProduct(handle).then(function (p) {
      var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      /* Subscribe & Save is pre-ticked (owner's choice, matching the product
         page's default); the shopper unticks for a one-time purchase. */
      var defaultPlan = (cfg.show_sub && cfg.sub_default && first.plans && first.plans[0]) ? first.plans[0].id : '';
      state = { product: p, variantId: first.id, planId: defaultPlan, qty: 1, busy: false };
      panel.classList.remove('is-loading');
      render();
      var f = sheet.querySelector('.qa-size.is-selected, .qa-plan.is-selected, [data-qa-add]');
      if (f) f.focus();
    }).catch(function () {
      /* Fall back to the product page if the data cannot be loaded. */
      close();
      location.href = '/products/' + handle;
    });
  }

  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { sheet.hidden = true; }, 180);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function add() {
    if (!state || state.busy) return;
    var c = current();
    if (!c.v.available) return;
    state.busy = true; render();
    var body = { items: [{ id: c.v.id, quantity: state.qty }] };
    if (c.plan) body.items[0].selling_plan = c.plan.id;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        state.busy = false;
        close();
        document.dispatchEvent(new CustomEvent('ascend:cart:added', { detail: { source: 'quick-add' } }));
        if (window.AscendCart && typeof window.AscendCart.refreshAndOpen === 'function') window.AscendCart.refreshAndOpen();
        else { var opener = document.querySelector('[data-cart-open]'); if (opener) opener.click(); }
      })
      .catch(function () { state.busy = false; render(); alert('Sorry — that could not be added to the cart. Please try again.'); });
  }

  /* Card buttons: the card is one big <a>, so the button is a <span> with
     data-quick-add="<handle>"; intercept the click before it navigates. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-quick-add]');
    if (!t) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault(); e.stopPropagation();
    open(t.getAttribute('data-quick-add'), t);
  }, true);

  window.AscendQuickAdd = { open: open, close: close };
})();
